export const LAUNDRY_ACCESSORIES = ['Part/Accessory', 'Pedestal'];
